var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cl f14 border-radius-5 padding-left-right bg-gray-5",staticStyle:{"height":"40px","line-height":"40px"}},[_c('div',{staticClass:"z"},[_vm._v(_vm._s(_vm.title))]),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }